import DashboardConfiguration from 'components/DynamicDashboard/DashboardConfiguration';
import i18n from 'i18n';
import React from 'react';
import { useEnvironmentsDashboard } from './useEnvironmentsDashboard';

interface EnvironmentsDashboardConfigurationProps {
  filters: Record<string, string>;
  selectedCards: string[];
  setSelectedCards: React.Dispatch<React.SetStateAction<string[]>>;
}

const EnvironmentsDashboardConfiguration = ({
  filters,
  selectedCards,
  setSelectedCards,
}: EnvironmentsDashboardConfigurationProps) => {
  const dashboardProps = useEnvironmentsDashboard({ filters });

  return (
    <DashboardConfiguration
      disableDashboardText={i18n.t('DONT_USE_ENV_DASHBOARD_KEY')}
      selectedCards={selectedCards}
      setSelectedCards={setSelectedCards}
      {...dashboardProps}
    />
  );
};

export default EnvironmentsDashboardConfiguration;
